import FrontendDeveloperPage from "./FrontendDeveloperPage";

export default function ReactDeveloperPage() {
  return <FrontendDeveloperPage technology="reactjs" />;
}
